var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Requester } from '@frontend-components/utils/requester';
import { getServiceUrlFor } from '@frontend-components/utils/urls';
import { setPurchaseSidebarOpen } from '../../slices/sidebarSlice';
import { useLazyGetBasketQuery } from '../../api/basket';
import HeaderFeature from '@frontend-components/features/Header';
import { getGlobalState } from '../../../Utils/GlobalState';
import './HeaderStyles.scss';
const Header = () => {
    const dispatch = useDispatch();
    const [user, setUser] = useState();
    const [isUserLoading, setUserLoading] = useState(false);
    const [fetchBasket, { data: basketData }] = useLazyGetBasketQuery();
    const handleClickBasket = () => {
        const applicationUrl = getGlobalState('application_url');
        dispatch(setPurchaseSidebarOpen(true));
        fetchBasket(applicationUrl);
    };
    useEffect(() => {
        const applicationUrl = getGlobalState('application_url');
        fetchUser();
        fetchBasket(applicationUrl);
    }, []);
    return (_jsx("div", Object.assign({ className: "testavivaHeader" }, { children: _jsx(HeaderFeature, { user: user, isUserLoading: isUserLoading, basketProductsCount: (basketData === null || basketData === void 0 ? void 0 : basketData.items) != null ? basketData.items.length : 0, redirectTo: (url) => {
                window.location.href = url;
            }, urls: {
                application: getGlobalState('application_url'),
                applicationSpa: getServiceUrlFor(window.location.href, 'app'),
                frontend: getServiceUrlFor(window.location.href, 'frontend')
            }, actions: { onClickBasket: handleClickBasket } }) })));
    function fetchUser() {
        return __awaiter(this, void 0, void 0, function* () {
            setUserLoading(true);
            const applicationUrl = getGlobalState('application_url');
            try {
                const { data } = yield Requester.get(`${applicationUrl}/api/user`, { withCredentials: true });
                setUser(data);
            }
            finally {
                setUserLoading(false);
            }
        });
    }
};
export default Header;
